import type { ProfileReward } from '@/modules/profile-completion/types';

export const ENDPOINT = 'api/app/profile';

export type Request = {
  name?: string;
  cpf?: string;
  email?: string;
  phone?: string;
  /** PRAT-161: AAAA-MM-DD, opcional. */
  birth_date?: string;
  /** PRAT-161: loja de onde o cliente veio (recompensa da loja e volta do link). */
  slug?: string;
};

export type Response = {
  /** PRAT-161: e-mail novo aguardando o clique no link de confirmação. */
  email_pending?: string | null;
  /** PRAT-161: recompensa ganha agora ao completar o perfil. */
  profile_rewards?: (ProfileReward & { code?: string })[];
} | void;
